module.exports = __webpack_public_path__ + "img/bj-pic.9bc37955.png";